import { render, staticRenderFns } from "./CTabBar.vue?vue&type=template&id=7569998c&scoped=true&"
import script from "./CTabBar.vue?vue&type=script&lang=js&"
export * from "./CTabBar.vue?vue&type=script&lang=js&"
import style0 from "./CTabBar.vue?vue&type=style&index=0&id=7569998c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569998c",
  null
  
)

export default component.exports